import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope, SchoolScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StorylandsHistoryResponse {
  storylands_history: {
    student_id: number
    total_attempts: number
    max_lesson: number
    lessons: { lesson: number; average_score: number }[]
  }[]
}

export type StorylandsHistoryData = StorylandsHistoryResponse['storylands_history']

export async function storylandsHistory(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentsScope | SchoolScope,
  period: NormalizedInterval,
): Promise<Nullable<StorylandsHistoryData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('storylands_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StorylandsHistoryResponse>(url, query)
  if (!data) return null

  const { storylands_history } = data
  if (storylands_history.length === 0) return null

  return storylands_history
}
